<template>
  <div id="connection">
    <v-row class="mb-10">
      <v-col align="center">
        <img v-if="logo" :src="logo" alt="logo" />
      </v-col>
    </v-row>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field v-model="agent_email" label="E-mail" variant="underlined" required id="ta-appsettings-email"></v-text-field>
      <v-text-field v-model="agent_password"  id="ta-appsettings-pasword" :rules="[rules.required, rules.min]" :type="show1 ? 'text' : 'password'"
        name="input-10-1" label="Password" variant="underlined" @click:append-inner="show1 = !show1"></v-text-field>
      <v-btn :disabled="!valid" @click="connect" id="ta-appsettings-connect">connect</v-btn>
      <p class="text-grey mb-1" v-if="isConnectFailed">{{ errorMessage }}</p>
      <v-progress-linear :indeterminate="true" height="5" color="green" v-if="isConnected"></v-progress-linear>
    </v-form>
    <v-dialog v-model="dialog" width="400">
      <v-card>
        <v-card-title class="bg-green-darken-1 text-black" primary-title>Available Datasets</v-card-title>

        <v-card-text class="text-grey-darken-1 pl-8 pt-1 pb-0" style="font-size: 12px;">Select a dataset to log in
          to:</v-card-text>
        <v-list lines="two" density="compact">
          <template v-for="(item) in datasets" :key="item.TenantId">
            <v-list-item ripple @click="selectDataset(item)" :class="'ta-dataset-'+item.TenantCode" >
              <v-list-item>
                <template v-slot:prepend>
                  <v-icon style="font-size: 42px;" class="dataset-text">mdi-database</v-icon>
                </template>
                <v-list-item-title class="dataset-text">{{ item.TenantName }}</v-list-item-title>
                <v-list-item-subtitle style="font-size:12px;">{{ item.Description}}</v-list-item-subtitle>
              </v-list-item>
            </v-list-item>
          </template>
        </v-list>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </div>
  <!-- </v-app> -->
</template>
  
<script lang="ts" >

import foot1 from "@/assets/actionListLogo.svg";
import * as Sentry from "@sentry/browser";
import { AdminCredentails } from "../constants/index";

import DataService from "@/services/data-service";
const dataService = new DataService();

import CryptoService from '@/services/crypto-services';
import { IDataset,IAgentInfo } from "@/interfaces";
import { AgentInfo } from "@/models";



const cryptoService = new CryptoService();
const datasets:IDataset[] = [];
const agentInfo:IAgentInfo = new AgentInfo();

export default {
  name: "appSettings",
  loading: true,
  data: () => ({
    logo: foot1,
    agent_email: "", 
    agent_password: "",
    agentInfo: agentInfo,
    datasets: datasets,
    rules: {
      required: (value: any) => !!value || "Required.",
      min: (v: any) => v.length >= 8 || "Min 8 characters",
      emailMatch: () => "The email and password you entered don't match",
    },
    valid: false,
    show1: false,
    select: false,
    dialog: false,
    isConnected: false,
    isConnectFailed: false,
    errorMessage: "Error Occured",
    youAreRestrictedToAccess: false,
    error: null,
    loading:false,
    isLoading:false,
  }),
  methods: {
    connect() {
      if (`${this.agent_email} ${this.agent_password}` === AdminCredentails) {
        this.$store.commit("setAdminLogin", { isAdminLoggedIn: true });
        this.$router.replace("/AdminPanel");
      } else {
        this.isConnectFailed = false;
        if (this.agent_email != "" && this.agent_password != "") {
          this.isConnected = true;
          dataService
            .connect(this.agent_email, this.agent_password)
            .then((success) => {
              this.agentInfo = success;
              this.$emit("agentConnected", this.agentInfo);
              if (success.Status && success.Status == true) {
                this.datasets = success.Datasets;
                this.dialog = true;
                this.isConnected = false;
                this.isConnectFailed = false;
              } else {
                this.isConnected = false;
                this.isConnectFailed = true;
                this.errorMessage = success.ErrorMessage ? success.ErrorMessage : "Email/Password is wrong.";
              }
            })
            .catch((err) => {
              console.log(err);
              this.error = err;
              this.isConnected = false;
              this.isConnectFailed = true;
            });
        }
      }
      //this.$router.replace("/login");
    },
    selectDataset(item: any) {
      const agentData = {
        AgentId: this.agentInfo.AgentId,
        SessionID: this.agentInfo.SessionID,
        TenantId: item.TenantId,
        TenantDesc: item.TenantName,
        AgentEmail: this.agent_email,
        AgentPassword: cryptoService.encryptString(this.agent_password),
      };
      if (this.agent_email != "") {
        let sentrytag = this.agent_email + " - " + item.TenantName;
        localStorage.setItem("sentrytag", sentrytag);
        Sentry.configureScope((scope) => {
          scope.setTag("tenant", sentrytag);
        });
      }
      this.$store.commit("setAgentInfo", agentData);
      this.$router.replace("/login");

      let result = dataService.UpdateTenantAgentsDesc("", item.TenantName);
    }
  },
};
</script>
  
  
<style>
body {
  background: #fff;
  font-family: Arial, Helvetica, sans-serif;
}

#connection {
  /* background: #fff;
    width: 30%;
    margin: auto auto auto auto; */
  border: 1px solid #ccc;
  padding: 2%;
  width: 30%;
  height: auto;
  background: #fff;

  position: absolute;
  /*it can be fixed too*/
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin-top: 70px;
  margin-bottom: 70px;
  margin-left: auto;
  margin-right: auto;

  /*this to solve "the content will not be cut when the window is smaller than the content": */
  max-width: 100%;
  max-height: 100%;
}

#connection img {
  width: 60%;
  display: block;
  margin-top: 70px;
  margin-bottom: 70px;
  margin-left: auto;
  margin-right: auto;
}

.page {
  position: fixed;
  width: inherit;
}

@media only screen and (max-width: 768px) {

  /* For mobile phones: */
  #connection {
    /* background: #fff;
    width: 30%;
    margin: auto auto auto auto; */
    border: 1px solid #ccc;
    padding: 5%;
    width: auto;
    height: auto;
    background: #fff;

    position: absolute;
    /*it can be fixed too*/
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: auto;
    margin-right: auto;

    /*this to solve "the content will not be cut when the window is smaller than the content": */
    max-width: 100%;
    max-height: 100%;
  }
}

/* @import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1"; */

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}

.router-anim-leave-active {
  animation: going 1s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}

@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.dataset-text{
  color:rgb(68, 138, 255) !important;
}
</style>